export const PRODUCTS_ACTIONS = {
    FIND: 'FIND_PRODUCTS',
    GET: 'GET_PRODUCTS',
    GET_LIST: 'GET_PRODUCTS_LIST',
    CHANGE_STATUS: 'CHANGE_STATUS_PRODUCTS',
    SUCCESS: 'SUCCESS_PRODUCTS',
    ERROR: 'ERROR_PRODUCTS',
    CLEAN: 'CLEAN_PRODUCTS',
}